import { useRecordContext } from 'react-admin';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';

/**
 * Ostrzeżenie o podejrzanych datach zlecenia z TMS klienta.
 *
 * Ocenę liczy API (`via/date-anomaly.ts`) i przysyła w `dateAnomaly`;
 * `null` albo brak pola = nic podejrzanego i nic nie pokazujemy. Daty na
 * karcie zostają takie, jak podał TMS — reguła ich nie poprawia, poprawka
 * należy do klienta, w jego systemie.
 */
export const DateAnomalyWarning = () => {
  const record = useRecordContext();
  const anomaly = record?.dateAnomaly as { reasons?: unknown } | null | undefined;
  const raw: unknown = anomaly?.reasons;
  const reasons = Array.isArray(raw)
    ? raw.filter((r): r is string => typeof r === 'string')
    : [];
  if (reasons.length === 0) return null;
  return (
    <Alert severity="warning">
      <AlertTitle>Podejrzane daty w TMS</AlertTitle>
      <Box component="ul" sx={{ m: 0, pl: 2 }}>
        {reasons.map((r) => (
          <li key={r}>
            <Typography variant="body2">{r}</Typography>
          </li>
        ))}
      </Box>
      <Typography variant="body2" sx={{ mt: 1 }}>
        Daty pokazujemy tak, jak są zapisane w TMS — sprawdź je i w razie potrzeby
        popraw w TMS. Na podstawie tego zlecenia nie tworzymy okien
        w harmonogramach pojazdów.
      </Typography>
    </Alert>
  );
};
